module.exports = require("rxjs/observable/of");